import EtablissementSoumisTva from '@/generated/controls/etablissement/EtablissementSoumisTva.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: EtablissementSoumisTva
})
